// extracted by mini-css-extract-plugin
export default {"wrapper":"request_wrapper__QUeYU","opacity-transition":"request_opacity-transition__lxH5L"};